<template>
  <div class="dashboard__grid__cell--boxed dashboard__grid__cell">
    <div class="dashboard__grid__cell__heading">
      <h2><i v-if="icon" :class="'icon--' + icon"></i> {{ title }}<small v-if="count"> ({{ count }} {{
        $t('general.total') }} {{addText}})</small></h2>
    </div>
    <div class="dashboard__grid__cell__body">
      <slot name="body"></slot>
    </div>

    <div class="btn--bar">
      <button v-if="button" @click="button" class="btn btn--center">
        <i :class="buttonIcon" v-if="buttonIcon"></i>
        {{ buttonText }}
      </button>
    </div>

    <slot name="footer"></slot>
  </div>
</template>

<script>
export default {
  name: 'Panel',
  props: ['title', 'size', 'count', 'button', 'buttonText', 'icon', 'buttonIcon', 'color', 'addText']
}
</script>
